<template>
   <div class="home">
     <header>
      <form action="jaegerexcute" method="get" style="height: 100%; color: white; font-size: 20pt;">
			<table style="height:100%; width:100%;" border="0">
				<tr style="height:30%;">
					<td align="center" valign="middle">
						<img src="../assets/img/jaeger.png" style="width: 40%;">						
					</td>
				</tr>
				<tr style="height:40%;">
					<td align="center" valign="middle">
						Digital Caliber Showcase Status Report<br><br>
						<div style="color: red;" :class="index === 0 ? 'hidden' : 'show'">Date Not Selected</div><br>
						Start Date: <input name="begDate" type="date"  v-model="beginTime" style="width: 50%; height: 50px; font-size: 20pt;"/><br><br>
						End Date: <input name="endDate" type="date" v-model="endTime" style="width: 50%; height: 50px; font-size: 20pt;margin-left:5px;"/><br><br><br><br>
						<input type="reset" name="submit" @click="time()" value="Generate Report" style="width: 20%; height: 56px; font-size: 20pt;cursor: pointer;text-align:center;"/>
					</td>
				</tr>
				<tr style="height:30%;">
					<td align="center" valign="middle">
						<img src="../assets/img/wonderlabs.png" style="width: 20%;">				
					</td>
				</tr>
			</table>
		</form>
    </header>
   </div>
</template>

<script>
import "axios";
import axios from 'axios'
import XLSX from 'xlsx'
export default {
  name: "home",
  data() {
    return {
			timeList: [],
			beginTime: '',
			endTime:'',
			index: 0,
			// 过滤月份
			dataMonth: [],
			dataYear: [],
			stayTimeAll: 0
    }
  },
  methods: {
	  time () {
		  if (this.beginTime === '' || this.endTime === ''){
				this.index = 1
				return
			}else {
				this.index = 0
			}

			var beginTimeStr = new Date(this.beginTime).toISOString().split('T')[0].replace(/\//g,"-")
			var endTimeStr = new Date(this.endTime).toISOString().split('T')[0].replace(/\//g,"-")
			var data = new Date()
      var year = new Date().getFullYear()
      var monthDay = data.getMonth() + 1 < 10 ? '0' +( data.getMonth() + 1) : data.getMonth() + 1
      var day = data.getDate() < 10 ? '0' + (data.getDate()) : data.getDate()
			var params = {
        nx_formid: "61de44d995c9854947e0f47e",
      };
			if (beginTimeStr < '2023-12-01') {
        params.starttime = {
          $gt: beginTimeStr + " 00:00:00",
          $lt: year + '-' + monthDay + '-' + day + " 23:59:59",
        }
       } else {
        params.starttime = {
          $gt: "2023-12-01 00:00:00",
          $lt: year + '-' + monthDay + '-' + day + " 23:59:59",
        }
       }
			axios.post('https://form.mixwechat.com/api/interface/info/onedata',params).then(res => {
				this.dataYear = res.data.data.filter(a => a.sid < 100)
				var filterTime = res.data.data.filter((p) => p.starttime >= beginTimeStr + " 00:00:00" && p.endtime <= endTimeStr + " 23:59:59")
				this.timeList = filterTime.filter(a => a.sid < 100)
				this.timeList.forEach((a) => {
					if (a.sid * 1 === 0) {
						a.sid = 'Shanghai K11'
					}else if (a.sid * 1 === 1) {
						a.sid = 'HK PP'
					} else if (a.sid * 1 === 3) {
						a.sid = 'Popup Event'
					} else if (a.sid * 1 === 4) {
						a.sid = 'HongKong PP'
					} else if (a.sid * 1 === 5) {
						a.sid = 'NewYork'
					} else if (a.sid * 1 === 6) {
						a.sid = 'Thailand'
					} else if (a.sid * 1 === 7) {
						a.sid = 'IB Munich'
					} else if (a.sid * 1 === 8) {
						a.sid = 'Singapore Marine Bay'
					} else if (a.sid * 1 === 9) {
						a.sid = 'Shengyang MixCity'
					}
					this.timeList.forEach((b) => {
						if (b.lang * 1 === 0) {
							b.lang = 'Chinese'
						} else if (b.lang * 1 === 1) {
							b.lang = 'English'
						} else if (b.lang * 1 === 2) {
							b.lang = 'Chinese traditional'
						} else if (b.lang * 1 === 3) {
							b.lang = 'French'
						} else if (b.lang * 1 === 4) {
							b.lang = 'German'
						} else if (b.lang * 1 === 5) {
							b.lang = 'Korean'
						}
					})
					// console.log(a.sid,a.lang)
				})
				this.dataYear.forEach((a) => {
					if (a.sid * 1 === 0) {
						a.sid = 'Shanghai K11'
					}else if (a.sid * 1 === 1) {
						a.sid = 'HK PP'
					} else if (a.sid * 1 === 3) {
						a.sid = 'Popup Event'
					} else if (a.sid * 1 === 4) {
						a.sid = 'HongKong PP'
					} else if (a.sid * 1 === 5) {
						a.sid = 'NewYork'
					} else if (a.sid * 1 === 6) {
						a.sid = 'Thailand'
					} else if (a.sid * 1 === 7) {
						a.sid = 'IB Munich'
					} else if (a.sid * 1 === 8) {
						a.sid = 'Singapore Marine Bay'
					} else if (a.sid * 1 === 9) {
						a.sid = 'Shengyang MixCity'
					}
					this.dataYear.forEach((b) => {
						if (b.lang * 1 === 0) {
							b.lang = 'Chinese'
						} else if (b.lang * 1 === 1) {
							b.lang = 'English'
						} else if (b.lang * 1 === 2) {
							b.lang = 'Chinese traditional'
						} else if (b.lang * 1 === 3) {
							b.lang = 'French'
						} else if (b.lang * 1 === 4) {
							b.lang = 'German'
						} else if (b.lang * 1 === 5) {
							b.lang = 'Korean'
						}
					})
				})

				//  ********** ---月--- **********
				const numberMonth = []
				this.timeList.forEach((p) => {
					const sidNumber = p.sid
					if (numberMonth[sidNumber]) {
						numberMonth[sidNumber]++;
					} else {
						numberMonth[sidNumber] = 1
					}
				})
				const newNumberMonth = []
				for (let i = 0; i < Object.keys(numberMonth).length; i++) {
					// 每次重新计算每个店铺所有的播放时间
					this.stayTimeAllMonth = 0
					
					let objList = {
						sid: '', 
						Number: 0,
						staytime: 0,
						calibre1: 0,
						calibre1ov: 0,
						calibre1fn: 0,
						calibre1rw: 0,
						calibre1gm: 0,
						calibre1st: 0,
						calibre2: 0,
						calibre2ov: 0,
						calibre2fn: 0,
						calibre2rw: 0,
						calibre2gm: 0,
						calibre2st: 0,
						calibre5: 0,
						calibre5ov: 0,
						calibre5fn: 0,
						calibre5rw: 0,
						calibre5gm: 0,
						calibre5st: 0,
						calibre4: 0,
						calibre4ov: 0,
						calibre4fn: 0,
						calibre4rw: 0,
						calibre4gm: 0,
						calibre4st: 0,
						calibre3: 0,
						calibre3ov: 0,
						calibre3fn: 0,
						calibre3rw: 0,
						calibre3gm: 0,
						calibre3st: 0,
					}
					
					this.timeList.filter(p => p.sid === Object.keys(numberMonth)[i]).forEach(item => {
						this.stayTimeAllMonth += item.staytime * 1 
						// Shop ID
						objList.sid = Object.keys(numberMonth)[i]
						// Number of User
						objList.Number = Object.values(numberMonth)[i]
						// Avg Stay (sec)
						objList.staytime = Math.round( this.stayTimeAllMonth * 1 / objList.Number * 1 )
						
						objList.calibre1 += item.calibre1
						objList.calibre1ov += item.calibre1ov
						objList.calibre1fn += item.calibre1fn
						objList.calibre1rw += item.calibre1rw
						objList.calibre1gm += item.calibre1gm
						objList.calibre1st += item.calibre1st
						objList.calibre2 += item.calibre2
						objList.calibre2ov += item.calibre2ov
						objList.calibre2fn += item.calibre2fn
						objList.calibre2rw += item.calibre2rw
						objList.calibre2gm += item.calibre2gm
						objList.calibre2st += item.calibre2st
						objList.calibre5 += item.calibre5
						objList.calibre5ov += item.calibre5ov
						objList.calibre5fn += item.calibre5fn
						objList.calibre5rw += item.calibre5rw
						objList.calibre5gm += item.calibre5gm
						objList.calibre5st += item.calibre5st
						objList.calibre4 += item.calibre4
						objList.calibre4ov += item.calibre4ov
						objList.calibre4fn += item.calibre4fn
						objList.calibre4rw += item.calibre4rw
						objList.calibre4gm += item.calibre4gm
						objList.calibre4st += item.calibre4st
						objList.calibre3 += item.calibre3
						objList.calibre3ov += item.calibre3ov
						objList.calibre3fn += item.calibre3fn
						objList.calibre3rw += item.calibre3rw
						objList.calibre3gm += item.calibre3gm
						objList.calibre3st += item.calibre3st
					
					})
					newNumberMonth.push(objList)
				}
				const columnArrMonth = [
					{
						name: 'SHOP id',
						keywords: 'sid'
					},
					{
						name: 'Number of User',
						keywords: 'Number'
					},
					{
						name: 'Avg Stay (sec)',
						keywords: 'staytime'
					},
					{
						name: 'Caliber_101',
						keywords: 'calibre1'
					},
					{
						name: 'Overview_101',
						keywords: 'calibre1ov'
					},
					{
						name: 'Function_101',
						keywords: 'calibre1fn'
					},
					{
						name: 'Related_101',
						keywords: 'calibre1rw'
					},
					{
						name: 'Game_101',
						keywords: 'calibre1gm'
					},
					{
						name: 'Story_101',
						keywords: 'calibre1st'
					},
					{
						name: 'Caliber_854A/2',
						keywords: "calibre2"
					},
					{
						name: 'Overview_854A/2',
						keywords: 'calibre2ov'
					},
					{
						name: 'Function_854A/2',
						keywords: 'calibre2fn'
					},
					{
						name: 'Related_854A/2',
						keywords: 'calibre2rw'
					},
					{
						name: 'Game_854A/2',
						keywords: 'calibre2gm'
					},
					{
						name: 'Story_854A/2',
						keywords: 'calibre2st'
					},
					{
						name: 'Caliber_978G',
						keywords: 'calibre5'
					},
					{
						name: 'Overview_978G',
						keywords: 'calibre5ov'
					},
					{
						name: 'Function_978G',
						keywords: 'calibre5fn'
					},
					{
						name: 'Related_978G',
						keywords: 'calibre5rw'
					},
					{
						name: 'Game_978G',
						keywords: 'calibre5gm'
					},
					{
						name: 'Story_978G',
						keywords: 'calibre5st'
					},
					{
						name: 'Caliber_956AA',
						keywords: 'calibre4'
					},
					{
						name: 'Overview_956AA',
						keywords: 'calibre4ov'
					},
					{
						name: 'Function_956AA',
						keywords: 'calibre4fn'
					},
					{
						name: 'Related_956AA',
						keywords: 'calibre4rw'
					},
					{
						name: 'Game_956AA',
						keywords: 'calibre4gm'
					},
					{
						name: 'Story_956AA',
						keywords: 'calibre4st'
					},
					{
						name: 'Caliber_868',
						keywords: 'calibre3'
					},
					{
						name: 'Overview_868',
						keywords: 'calibre3ov'
					},
					{
						name: 'Function_868',
						keywords: 'calibre3fn'
					},
					{
						name: 'Related_868',
						keywords: 'calibre3rw'
					},
					{
						name: 'Game_868',
						keywords: 'calibre3gm'
					},
					{
						name: 'Story_868',
						keywords: 'calibre3st'
					}
					
					
				]
				const theKeysMonth = columnArrMonth.map(k => k.keywords)
				const headersMonth = columnArrMonth.map(k => k.name)
				const aoaDataMonth = [headersMonth]
				newNumberMonth.forEach(d => {
					const saveArray = []
					theKeysMonth.forEach(key => {
						if (d[key] === undefined) {
						d[key] = ''
						}
						saveArray.push(d[key])
					})
					aoaDataMonth.push(saveArray)
				})
				// ********** ---月 END--- **********


				// ********** ---年--- **********
				const number = []
				this.dataYear.forEach((p) => {
					const sidNumber = p.sid
					if (number[sidNumber]) {
						number[sidNumber]++;
					} else {
						number[sidNumber] = 1
					}
				})
				const newNumber = []
				for (let i = 0; i < Object.keys(number).length; i++) {
					// 每次重新计算每个店铺所有的播放时间
					this.stayTimeAll = 0
					
					let objList = {
						sid: '', 
						Number: 0,
						staytime: 0,
						calibre1: 0,
						calibre1ov: 0,
						calibre1fn: 0,
						calibre1rw: 0,
						calibre1gm: 0,
						calibre1st: 0,
						calibre2: 0,
						calibre2ov: 0,
						calibre2fn: 0,
						calibre2rw: 0,
						calibre2gm: 0,
						calibre2st: 0,
						calibre5: 0,
						calibre5ov: 0,
						calibre5fn: 0,
						calibre5rw: 0,
						calibre5gm: 0,
						calibre5st: 0,
						calibre4: 0,
						calibre4ov: 0,
						calibre4fn: 0,
						calibre4rw: 0,
						calibre4gm: 0,
						calibre4st: 0,
						calibre3: 0,
						calibre3ov: 0,
						calibre3fn: 0,
						calibre3rw: 0,
						calibre3gm: 0,
						calibre3st: 0,
					}
					
					this.dataYear.filter(p => p.sid === Object.keys(number)[i]).forEach(item => {
						this.stayTimeAll += item.staytime * 1 
						// Shop ID
						objList.sid = Object.keys(number)[i]
						// Number of User
						objList.Number = Object.values(number)[i]
						// Avg Stay (sec)
						objList.staytime = Math.round( this.stayTimeAll * 1 / objList.Number * 1 )
						
						objList.calibre1 += item.calibre1
						objList.calibre1ov += item.calibre1ov
						objList.calibre1fn += item.calibre1fn
						objList.calibre1rw += item.calibre1rw
						objList.calibre1gm += item.calibre1gm
						objList.calibre1st += item.calibre1st
						objList.calibre2 += item.calibre2
						objList.calibre2ov += item.calibre2ov
						objList.calibre2fn += item.calibre2fn
						objList.calibre2rw += item.calibre2rw
						objList.calibre2gm += item.calibre2gm
						objList.calibre2st += item.calibre2st
						objList.calibre5 += item.calibre5
						objList.calibre5ov += item.calibre5ov
						objList.calibre5fn += item.calibre5fn
						objList.calibre5rw += item.calibre5rw
						objList.calibre5gm += item.calibre5gm
						objList.calibre5st += item.calibre5st
						objList.calibre4 += item.calibre4
						objList.calibre4ov += item.calibre4ov
						objList.calibre4fn += item.calibre4fn
						objList.calibre4rw += item.calibre4rw
						objList.calibre4gm += item.calibre4gm
						objList.calibre4st += item.calibre4st
						objList.calibre3 += item.calibre3
						objList.calibre3ov += item.calibre3ov
						objList.calibre3fn += item.calibre3fn
						objList.calibre3rw += item.calibre3rw
						objList.calibre3gm += item.calibre3gm
						objList.calibre3st += item.calibre3st
					
					})
					newNumber.push(objList)
				}
				const columnArrYear = [
					{
						name: 'SHOP id',
						keywords: 'sid'
					},
					{
						name: 'Number of User',
						keywords: 'Number'
					},
					{
						name: 'Avg Stay (sec)',
						keywords: 'staytime'
					},
					{
						name: 'Caliber_101',
						keywords: 'calibre1'
					},
					{
						name: 'Overview_101',
						keywords: 'calibre1ov'
					},
					{
						name: 'Function_101',
						keywords: 'calibre1fn'
					},
					{
						name: 'Related_101',
						keywords: 'calibre1rw'
					},
					{
						name: 'Game_101',
						keywords: 'calibre1gm'
					},
					{
						name: 'Story_101',
						keywords: 'calibre1st'
					},
					{
						name: 'Caliber_854A/2',
						keywords: "calibre2"
					},
					{
						name: 'Overview_854A/2',
						keywords: 'calibre2ov'
					},
					{
						name: 'Function_854A/2',
						keywords: 'calibre2fn'
					},
					{
						name: 'Related_854A/2',
						keywords: 'calibre2rw'
					},
					{
						name: 'Game_854A/2',
						keywords: 'calibre2gm'
					},
					{
						name: 'Story_854A/2',
						keywords: 'calibre2st'
					},
					{
						name: 'Caliber_978G',
						keywords: 'calibre5'
					},
					{
						name: 'Overview_978G',
						keywords: 'calibre5ov'
					},
					{
						name: 'Function_978G',
						keywords: 'calibre5fn'
					},
					{
						name: 'Related_978G',
						keywords: 'calibre5rw'
					},
					{
						name: 'Game_978G',
						keywords: 'calibre5gm'
					},
					{
						name: 'Story_978G',
						keywords: 'calibre5st'
					},
					{
						name: 'Caliber_956AA',
						keywords: 'calibre4'
					},
					{
						name: 'Overview_956AA',
						keywords: 'calibre4ov'
					},
					{
						name: 'Function_956AA',
						keywords: 'calibre4fn'
					},
					{
						name: 'Related_956AA',
						keywords: 'calibre4rw'
					},
					{
						name: 'Game_956AA',
						keywords: 'calibre4gm'
					},
					{
						name: 'Story_956AA',
						keywords: 'calibre4st'
					},
					{
						name: 'Caliber_868',
						keywords: 'calibre3'
					},
					{
						name: 'Overview_868',
						keywords: 'calibre3ov'
					},
					{
						name: 'Function_868',
						keywords: 'calibre3fn'
					},
					{
						name: 'Related_868',
						keywords: 'calibre3rw'
					},
					{
						name: 'Game_868',
						keywords: 'calibre3gm'
					},
					{
						name: 'Story_868',
						keywords: 'calibre3st'
					}
					
					
				]
				const theKeysYear = columnArrYear.map(k => k.keywords)
				const headersYear = columnArrYear.map(k => k.name)
				const aoaDataYear = [headersYear]
				newNumber.forEach(d => {
					const saveArray = []
					theKeysYear.forEach(key => {
						if (d[key] === undefined) {
						d[key] = ''
						}
						saveArray.push(d[key])
					})
					aoaDataYear.push(saveArray)
				})
				// ********** ---年 END--- **********




				// Sheet1
				var beginTime = beginTimeStr.replace(/[-/]/g,"")
				var endTime = endTimeStr.replace(/[-/]/g,"")
				console.log('time', beginTime, endTime)
				const filename = 'JLC Digital Showcase Report_' + beginTime + '_' + endTime + '.xlsx'

				const columnArr = [
					{
						name: 'SHOP id',
						keywords: 'sid'
					},
					{
						name: 'START TIME',
						keywords: 'starttime'
					},	
					{
						name: 'END TIME',
						keywords: 'endtime'
					},
					{
						name: 'STAY TIME',
						keywords: 'staytime'
					},
					{
						name: 'Language',
						keywords: 'lang'
					},
					{
						name: 'Caliber_101',
						keywords: 'calibre1'
					},
					{
						name: 'Overview_101',
						keywords: 'calibre1ov'
					},
					{
						name: 'Function_101',
						keywords: 'calibre1fn'
					},
					{
						name: 'Related_101',
						keywords: 'calibre1rw'
					},
					{
						name: 'Game_101',
						keywords: 'calibre1gm'
					},
					{
						name: 'Story_101',
						keywords: 'calibre1st'
					},
					{
						name: 'Caliber_854A/2',
						keywords: "calibre2"
					},
					{
						name: 'Overview_854A/2',
						keywords: 'calibre2ov'
					},
					{
						name: 'Function_854A/2',
						keywords: 'calibre2fn'
					},
					{
						name: 'Related_854A/2',
						keywords: 'calibre2rw'
					},
					{
						name: 'Game_854A/2',
						keywords: 'calibre2gm'
					},
					{
						name: 'Story_854A/2',
						keywords: 'calibre2st'
					},
					{
						name: 'Caliber_978G',
						keywords: 'calibre5'
					},
					{
						name: 'Overview_978G',
						keywords: 'calibre5ov'
					},
					{
						name: 'Function_978G',
						keywords: 'calibre5fn'
					},
					{
						name: 'Related_978G',
						keywords: 'calibre5rw'
					},
					{
						name: 'Game_978G',
						keywords: 'calibre5gm'
					},
					{
						name: 'Story_978G',
						keywords: 'calibre5st'
					},
					{
						name: 'Caliber_956AA',
						keywords: 'calibre4'
					},
					{
						name: 'Overview_956AA',
						keywords: 'calibre4ov'
					},
					{
						name: 'Function_956AA',
						keywords: 'calibre4fn'
					},
					{
						name: 'Related_956AA',
						keywords: 'calibre4rw'
					},
					{
						name: 'Game_956AA',
						keywords: 'calibre4gm'
					},
					{
						name: 'Story_956AA',
						keywords: 'calibre4st'
					},
					{
						name: 'Caliber_868',
						keywords: 'calibre3'
					},
					{
						name: 'Overview_868',
						keywords: 'calibre3ov'
					},
					{
						name: 'Function_868',
						keywords: 'calibre3fn'
					},
					{
						name: 'Related_868',
						keywords: 'calibre3rw'
					},
					{
						name: 'Game_868',
						keywords: 'calibre3gm'
					},
					{
						name: 'Story_868',
						keywords: 'calibre3st'
					}
					
					
				]
				const theKeys = columnArr.map(k => k.keywords)
				const headers = columnArr.map(k => k.name)
				const aoaData = [headers]
				this.timeList.forEach(d => {
					const saveArray = []
					theKeys.forEach(key => {
						if (d[key] === undefined) {
						d[key] = ''
						}
						saveArray.push(d[key])
					})
					aoaData.push(saveArray)
				})

				const wsName = 'Sheet1'

				const wb = XLSX.utils.book_new()
		
				const ws = XLSX.utils.aoa_to_sheet(aoaData)
				// 月
				const wsMonthName = new Date(this.beginTime).toLocaleString("en-US", { month: "long" })
				const wsMonth = XLSX.utils.aoa_to_sheet(aoaDataMonth)
				// 年
				const wsYearName = 'YEAR'

				const wsYear = XLSX.utils.aoa_to_sheet(aoaDataYear)
				/* add worksheet to workbook */
				XLSX.utils.book_append_sheet(wb, ws, wsName)
				XLSX.utils.book_append_sheet(wb, wsMonth, wsMonthName)
				XLSX.utils.book_append_sheet(wb, wsYear, wsYearName)

				/* write workbook */
				XLSX.writeFile(wb, filename)
			})
			
		}
  }
};
</script>
<style scoped>
.home{
    height: 100%;
}
header{
    padding: 0;
	margin: 0;
	background-color: black;
	overflow: auto;
    height: 100%;
}
input{
    padding: 0 10px;

}
.show{
	display: block;
}
.hidden{
	display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue